import {getJWTToken} from '../middleware/dataStorage';

export const getAccessToken = (navigate) => {
	let at = getJWTToken();
	if (at) {
		return at;
	} else {
		navigate('/login');
	}
}
